export enum ACCOUNT_TYPES {
    RENTER = 'Renter',
    AGENT = 'Agent',
}
